import React from "react";
import { Inbox, AlertTriangle, RotateCcw } from "lucide-react";
import "./ui.scss";

export const EmptyState = ({
  icon,
  title = "Nothing here yet",
  description,
  action,
}) => (
  <div className="hr-state">
    <div className="hr-state__icon" aria-hidden="true">
      {icon || <Inbox size={22} />}
    </div>
    <h3>{title}</h3>
    {description && <p>{description}</p>}
    {action && <div className="hr-state__actions">{action}</div>}
  </div>
);

export const ErrorState = ({
  title = "Something went wrong",
  message,
  onRetry,
}) => (
  <div className="hr-state hr-state--error" role="alert">
    <div className="hr-state__icon" aria-hidden="true">
      <AlertTriangle size={22} />
    </div>
    <h3>{title}</h3>
    {message && <p>{message}</p>}
    {onRetry && (
      <div className="hr-state__actions">
        <button
          type="button"
          className="hr-btn hr-btn--secondary"
          onClick={onRetry}
        >
          <RotateCcw size={15} aria-hidden="true" />
          Retry
        </button>
      </div>
    )}
  </div>
);

export const Skeleton = ({ className = "" }) => (
  <span className={`hr-skeleton ${className}`} />
);
